import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReportsContainer from './reports-container';
import { getReportTypeByToken } from '../../api/reports';
import { useAuth } from '../../providers/auth-provider';
function CandidateReportLink() {
  const auth = useAuth();
  const { token } = useParams();
  const [reportType, setReportType] = useState(0);

  useEffect(() => {
    getReportTypeByToken(auth, token).then((key) => {
      setReportType(key);
    });
  }, [token]);

  return <>{reportType && <ReportsContainer reportType={reportType} />}</>;
}

export default CandidateReportLink;
